import { useContext } from 'react';
import { AxonAccountContext } from '../../contexts/axon_account';
export const useAxonAccountContext = () => {
    const { account } = useContext(AxonAccountContext);
    if (!account) {
        throw new Error('useAxonAccountContext should be used within AxonAccountContext');
    }
    return account;
};
